import { useEventBus } from '@vueuse/core'

export const emailContentBus = useEventBus<string>('email-content-update')
export const pageContentBus = useEventBus<Record<string, any>>('page-content-update')
export const pageSettingsBus = useEventBus<Record<string, any>>('page-settings-update')
export const pageMetadataBus = useEventBus<{ name?: string; slug?: string }>(
  'page-metadata-update'
)
